import { useState } from 'react';

export const useProductEditorState = () => {
    const [editingInternet, setEditingInternet] = useState(null);
    const [savingInternetDraft, setSavingInternetDraft] = useState(false);
    const [editingHomePhone, setEditingHomePhone] = useState(null);
    const [savingHomePhoneDraft, setSavingHomePhoneDraft] = useState(false);
    const [editingCatalog, setEditingCatalog] = useState(null);
    const [savingCatalogDraft, setSavingCatalogDraft] = useState(false);
    const [editingTvDisplay, setEditingTvDisplay] = useState(null);
    const [savingTvDisplayDraft, setSavingTvDisplayDraft] = useState(false);
    const [editingEmailShell, setEditingEmailShell] = useState(null);
    const [savingEmailShellDraft, setSavingEmailShellDraft] = useState(false);
    const [emailShellPreviewOpen, setEmailShellPreviewOpen] = useState(false);

    return {
        editingInternet,
        setEditingInternet,
        savingInternetDraft,
        setSavingInternetDraft,
        editingHomePhone,
        setEditingHomePhone,
        savingHomePhoneDraft,
        setSavingHomePhoneDraft,
        editingCatalog,
        setEditingCatalog,
        savingCatalogDraft,
        setSavingCatalogDraft,
        editingTvDisplay,
        setEditingTvDisplay,
        savingTvDisplayDraft,
        setSavingTvDisplayDraft,
        editingEmailShell,
        setEditingEmailShell,
        savingEmailShellDraft,
        setSavingEmailShellDraft,
        emailShellPreviewOpen,
        setEmailShellPreviewOpen
    };
};
